import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models/Model';

export interface IRxSKUItemQuantityModel extends IModel {
  rxSKUItemQuantityId: number;
  rxSKUItemId: number;
  quantity: number;
  sku: string;
}

export class RxSKUItemQuantityModel
  extends Model
  implements ModelRecord<IRxSKUItemQuantityModel>
{
  rxSKUItemQuantityId: number;
  rxSKUItemId: number;
  quantity: number;
  sku: string;

  constructor(params?: Partial<IRxSKUItemQuantityModel>) {
    super(params);
    this.rxSKUItemQuantityId = defaultTo(params?.rxSKUItemQuantityId, 0);
    this.rxSKUItemId = defaultTo(params?.rxSKUItemId, 0);
    this.quantity = defaultTo(params?.quantity, 0);
    this.sku = defaultTo(params?.sku, '');
  }
}
